import moment from 'moment';
import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import { getStringHidden } from '../../../views/ganttContainer/gantt/gantt.helper';
import { dateStartEditor } from '../../../assets/js/field_config/editor-inline-gantt';

const startDateCol = (gantt, t) => {
  const name = 'start_date';
  const isVisible = isColumnVisibleByDefault(name);

  return {
    name,
    label: t('gantt.columns.startDate', 'Inicio'),
    align: 'center',
    resize: true,
    width: '75',
    editor: dateStartEditor,
    template: (activity) => {
      const hasChild = gantt.hasChild(activity.id);
      const momentDate = moment(activity.start_date);
      const dateFormat = gantt?.currentDateFormat || 'YYYY-MM-DD';
      const momentDateStr = momentDate.format(dateFormat).toString();
      const isOdd = gantt.oddColsConfig?.start_date || false;
      const htmlH = getStringHidden(momentDateStr, name);

      return `
        <div class="${isOdd ? 'odd-col' : 'non-odd-col'}" style="${hasChild ? 'font-weight: 600' : 'font-weight: 100'}; color: #121212;">
          <span class="string-v">${momentDate.format(dateFormat.replace('hh', 'HH'))}</span>
          ${htmlH}
        </div>
      `;
    },
    hide: !isVisible,
    data_type: 'date',
    groupable: false,
    orderable: true,
    orderable_switch: ['1 → N', 'N → 1'],
    filterable: true,
  };
};

export default startDateCol; 